import React from 'react';
import { useTranslation } from 'react-i18next';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import ComparisonTable from "../../../components/ComparisonTable/ComparisonTable";
import SEO from "../../../utils/SEO";

export default function PanamaJurisdiction() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.panama-jurisdiction.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/panama-jurisdiction"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/jurisdictions/panama.jpg')}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">

                    <h1 className='section-title'>
                        {tp('licensesHeading')}
                    </h1>

                    <WhySection
                        title={tp('banking.title')}
                        subtitle={tp('banking.subtitle')}
                        blocks={[{ items: obj('banking.items') }]}
                        end={tp('banking.end')}
                    />

                    <InfoBlocks
                        title={tp('payments.title')}
                        subtitle={tp('payments.subtitle')}
                        blocks={[{ items: obj('payments.items') }]}
                        end={tp('payments.end')}
                    />

                    <LocationTimeline
                        title={tp('crypto.title')}
                        subtitle={tp('crypto.subtitle')}
                        item={obj('crypto.items')}
                        end={tp('crypto.end')}
                    />

                    <ServiceCards
                        title={tp('insurance.title')}
                        subtitle={tp('insurance.subtitle')}
                        services={obj('insurance.items')}
                        end={tp('insurance.end')}
                    />

                    <FeatureCards
                        title={tp('funds.title')}
                        subtitle={tp('funds.subtitle')}
                        features={obj('funds.items')}
                        end={tp('funds.end')}
                    />

                    <FeatureCards
                        title={tp('trusts.title')}
                        subtitle={tp('trusts.subtitle')}
                        features={obj('trusts.items')}
                        end={tp('trusts.end')}
                    />

                    <FeatureCards
                        title={tp('shipping.title')}
                        subtitle={tp('shipping.subtitle')}
                        features={obj('shipping.items')}
                        end={tp('shipping.end')}
                    />

                    <FeatureCards
                        title={tp('gaming.title')}
                        subtitle={tp('gaming.subtitle')}
                        features={obj('gaming.items')}
                    />

                    <ComparisonTable
                        title={tp('comparison.title')}
                        columns={obj('comparison.columns')}
                        data={obj('comparison.rows')}
                    />

                    <DetailsSection
                        title={tp('whyUs.title')}
                        items={obj('whyUs.items')}
                    />

                    <FeatureCards
                        title={tp('bestUses.title')}
                        features={obj('bestUses.items')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};
